import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const BundleListingPage = () => {
  return /*#__PURE__*/_jsx("h1", {
    children: "App Bundles Listing Page will go here"
  });
};
export { BundleListingPage };